import { requireService } from '@repo/di-ez';
import type { GridEventListener, GridApi } from '@repo/go-table';
import { useCallback } from 'react';
import type { MutableRefObject } from 'react';

import { handleTrajectoryPaste } from '../trajectory-key-actions';

type TypeTrajStationOption = { value: string; label: string };

type UseTableEventHandlersOptions = {
  tableApi: MutableRefObject<GridApi>;
  isEditing: boolean;
  typeTrajStationOptions: readonly TypeTrajStationOption[];
};

export const useTableEventHandlers = ({
  tableApi,
  isEditing,
  typeTrajStationOptions,
}: UseTableEventHandlersOptions) => {
  const notifications = requireService('trajectoryNotifications');
  const uiStore = requireService('trajectoryUiStore');
  const trajectoryService = requireService('trajectoryService');
  const validationStore = requireService('trajectoryTableValidationStore');

  const onCopy: GridEventListener<'clipboardCopy'> = useCallback(
    (data) => {
      if (!data) {
        return;
      }

      uiStore.setSelectedRowIds([]);
      notifications.showSuccessMessageT('common:dataCopied');
    },
    [notifications, uiStore],
  );

  const onBeforeClipboardPasteStart = useCallback(
    ({ data }: { data: string[][] }) => {
      handleTrajectoryPaste({
        tableApi,
        trajectoryService,
        validationStore,
        clipboardRows: data,
        isEditing,
        typeTrajStationOptions,
      });

      // Domain service applies paste values. Reject to prevent MUI default paste.
      return Promise.reject();
    },
    [isEditing, tableApi, trajectoryService, typeTrajStationOptions, validationStore],
  );

  return { onCopy, onBeforeClipboardPasteStart };
};
